import React from "react"
import styled, { css } from "styled-components"
import { mixins, StyledForm } from "Styles"
import { theme } from "Theme"
import { QuerySelect, StyledSelect, Spacer } from "Components/FormElements"
import Config from "Data"

export class StepsEventSelect extends React.Component {
  render() {
    const { events, options, optionsLink, showEvents } = this.props
    return (
      <>
        <StyledForm>
          {showEvents && (
            <QuerySelect
              label="Which event interest you?"
              name="events"
              placeholder="Please select one"
              value={[]}
              options={events}
              isMulti={false}
              className="fullWidthElement"
            />
          )}
          {options && (
            <StyledSelect
              optionsLink={optionsLink ? "/options" : ""}
              label="Options:"
              name="options"
              placeholder="Please select one"
              value={[]}
              data-gtm={"Sponsorship Options Select"}
              options={[
                { label: "Access Pass", value: "Access Pass" },
                { label: "Exhibit", value: "Exhibit" },
                {
                  label: "Exhibit + Content",
                  value: "Exhibit + Content",
                },
                { label: "Premier", value: "Premier" },
                {
                  label: "Premier + Content",
                  value: "Premier + Content",
                },
              ]}
              className="fullWidthElement"
            />
          )}

          <StyledSelect
            label={`Are private ${Config.audience} dinners of interest; an intimate audience of 25 leaders gather over dinner and cocktails?`}
            name="dinner"
            placeholder="Please select an answer"
            value={[]}
            options={[
              { label: "Yes", value: "Yes" },
              { label: "No", value: "No" },
            ]}
            className="fullWidthElement"
          />

          <div className="buttonsWrapper">
            <button type="button" className="btn" onClick={this.props.nextStep} data-gtm={`Form Sponsor | Next`}>
              Next
            </button>
          </div>
        </StyledForm>
      </>
    )
  }
}

export default StepsEventSelect
